module.exports = __webpack_public_path__ + "img/logo.bdd48fd9.svg";